import { useEffect, useState } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};
const memoryService = {
  _main_url: process.env.REACT_APP_AUTH_API_URL,

  GetMemoryList(agent_id, fetch) {
    const [data, setsData] = useState({
      sessions: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getAllMemories(agent_id))
        .then(res => {
          setsData(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [agent_id, fetch]);

    return {
      _loading: status === STATUS.LOADING,
      _error: status === STATUS.ERROR,
      _data: data,
    };
  },

  async getAllMemories(agent_id) {
    return await Fetch.get(`${this._main_url}/memory/list?agent_id=${agent_id}`);
  },

  async deleteMemory(id) {
    return await Fetch.delete(`${this._main_url}/memory/delete?memory_id=${id}`);
  },

  async updateMemory(payload) {
    return await Fetch.put(`${this._main_url}/memory/update`, payload);
  },
};

export default memoryService;
